import { render, staticRenderFns } from "./AdminIndex.vue?vue&type=template&id=6108a1f3&scoped=true"
import script from "./AdminIndex.vue?vue&type=script&lang=js"
export * from "./AdminIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6108a1f3",
  null
  
)

export default component.exports